<template>
	<div id="mycenter">
		<div class="mycenter_info">
			<div class="imgbox">
				<img  v-show="!form.Photo" class="Photo" src="../assets/zanwu.jpg" alt="">
				<img v-show="form.Photo" class="Photo" :src="form.RootPath+form.Photo" alt="">
			</div>
			<div class="info">
				<div class="name" v-text="form.UserName"></div>
				<div class="Org">
					<div class="title">机构名称</div>
					<div v-text='form.Org||"未填写"'></div>
				</div>
				<div class="area">
					<div class="title">所在地区</div>
					<div v-text="form.ProvinceName+'-'+form.CityName"></div>
				</div>
				<div class="time">
					<div class="title">从业时间</div>
					<div v-text="form.WorkingStart+'年'"></div>
				</div>
			</div>
		</div>
		<div class="list">
			<div class="title">参赛宣言：</div>
			<div class="text" v-text="form.Declaration||'未填写'"></div>
		</div>
		<div class="list">
			<div class="title">专业擅长：</div>
			<div class="text" v-text='form.MajorIds||"未填写"'>啊死了咖喱世界观啊介绍个就撒挂上</div>
		</div>
		<div class="list">
			<div class="title">所持证书：</div>
			<div class="text" v-text='form.CertIds||"无"'></div>
		</div>
		
		<h1 class="resume_title">个人简历</h1>
		<textarea readonly="readonly" class="resume" :value='form.Introduction||"未填写"'></textarea>
		<!-- <button></button> -->
		<div style="height: 25px;"></div>
		<div class="operation" v-if="form.RegistType==0">
			<button class="personal" @click="registrants()">个人报名</button>
			<button @click="Shutdown()">团队报名</button>
		</div>
		<div class="operation" v-if="form.RegistType==1">
			<button @click="$router.push('/myTeam')">我的团队</button>
		</div>
	</div>
</template>

<script>
	import { MessageBox } from 'mint-ui';

	export default{
		data(){
			return{
				form:{
					UserName:'',//名称
					Declaration:'',//宣言
					Introduction: '',//介绍
					WorkingStart:'',//从业时间
					ProvinceId:'',//省
					CityId:'',//市
					Cert:[],//持证
					Major:[],//擅长
				},
			}
		},
		
		created(){
			
			// localStorage.removeItem("competition_cookie")
			var competition_cookie = localStorage.getItem("competition_cookie")
			console.log(competition_cookie)
			if(competition_cookie){
				this.getmember()
			}else{
				MessageBox('提示', '请先登录！');
				this.$router.push('/login');
				
			}
			
		},
		methods:{
			registrants(){
				var competition_info = JSON.parse(localStorage.getItem('competition_info'))
				console.log(this.form.UserName)
				if(this.form.UserName){
					if(competition_info.RegistType == 1||competition_info.RegistType == 2){
						MessageBox('提示', '你已报名，不可重复报名！');
					}else{
						MessageBox.confirm('个人参赛将不能参加团队比赛，请确认是否报名！').then(action => {
						  this.$http.post('/api/CompetitionRegist/PesonRegist')
						  .then(res => {
								if(res.data.Success){
									
									MessageBox('提示', '报名成功,请用电脑浏览器访问http://beijing.top10fp.com进行答题!');
									this.RegistType = 2
									var competition_info = JSON.parse(localStorage.getItem('competition_info'))
									competition_info.RegistType = 2
									localStorage.setItem("competition_info",JSON.stringify(competition_info))
									this.form.RegistType = 2
								}else{
									MessageBox('提示', res.data.ErrorMsg);
								}
						  })
						  .catch(error => {
							console.log(error)
						  })
						});
													
					}
				}else{
					MessageBox.confirm('请先完善个人信息！',{
						confirmButtonClass:'确定',
					}).then(action => {
					  this.$router.push('/editMyCenter')
					});
				}
				
			},
			Shutdown(){
				var competition_info = JSON.parse(localStorage.getItem('competition_info'))
				if(this.form.UserName){
					if(competition_info.RegistType == 1||competition_info.RegistType == 2){
						MessageBox('提示', '你已报名，不可重复报名！');
					}else{
						 this.$router.push('/TeamSignUp')
					}
				}else{
					MessageBox.confirm('请先完善个人信息！',{
						confirmButtonClass:'确定',
					}).then(action => {
					  this.$router.push('/editMyCenter')
					});
				}
			},
			getmember(){
				this.$http.get('/api/member/GetMember')
				.then(res => {
					var reg =/[\u4e00-\u9fa5]/g;
					var str = res.data.data.CertIds?res.data.data.CertIds:'';
					res.data.data.CertIds = str.replace(reg, "");
					this.form = res.data.data
				})
				.catch(error => {
				  console.log(error)
				})
			},
		}
	}
</script>

<style scoped="scoped" lang="scss">
	#mycenter{
		padding:1rem 0.8rem;box-sizing: border-box;
		.mycenter_info{
			display: flex;
			.imgbox{
				width: 7.5rem;
				height: 9rem;
				background: #dbdcdd;
				display: flex;align-items: center;
				overflow: hidden;
				.Photo{
					width:100%;
					
				}
			}
			.info{
				flex: 1;
				height: 9rem;
				padding-left: 10px;
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				.Org,.area,.time{display: flex;font-size: 0.9rem;
					.title{
						margin-right: 1rem;
						color: #2c3e50;
						white-space: nowrap; 
					}
					div{color: #666}
				}
				.name{font-size: 1.1rem;margin: 20px 0;}
			}
		}
		.list{
			display: flex;
			font-size:0.9rem;
			margin-top: 1rem;
			line-height: 1.4rem;
			.title{
				white-space: nowrap;
				color: #2c3e50;
			}
			div{color: #666}
		}
		.resume_title{text-align: center;font-size: 1.1rem;margin: 2rem 0 1rem 0}
		.resume{color: #666;font-size: 0.9rem;line-height: 1.4rem;width: 100%;border: none;height: 400px}
		.operation{position: fixed;width: 100%;height: 40px;line-height: 40px;background: #3E1976;bottom: 0;left: 0;color: #fff;display: flex;align-items: center;
			button{
				color: #fff;
				background: #3E1976;border: none;flex: 1;
			}
			.personal{
				background: #fff;color: #3E1976;
				border: 1px solid #3E1976;height: 40px;line-height: 40px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/mycenter.vue